<app-shipment-system-simplenav></app-shipment-system-simplenav>

<div class="container">
    <h2>Væktøjer</h2>
    <div class="mb-2 p-3 border rounded">
        <h3>End Of Day</h3>
        <div class="mb-3 mt-3">
            <label class="control-label" i18n>Afdeling</label>
            <input type="text" class="form-control" [(ngModel)]="branch" name="branch" [readOnly]="true" disabled>
        </div>

        <div>
            <label class="form-check-label">
    <input type="checkbox" [(ngModel)]="endIfDayParam.automatic" name="automatic" class="form-check-input">
                Automatisk</label>
        </div>
        <div class="mb-3 mt-3" *ngIf="!endIfDayParam.automatic">

            <label class="control-label" i18n>Dato</label>
            <app-date-time-picker [(date)]="endIfDayParam.date"
                                  [options]="{calendarWeeks:true, format: 'DD-MM-YYYY'}"
                                  [inputSmall]="true"
                                  (dateChange)="startDateChanged($event)"
                                  id="shipment-system-start-date"
                                  type="text"
                                  name="calendarWeeks"></app-date-time-picker>

        </div>
        <div class="mb-3 mt-3">
            <label class="control-label" i18n>Carrier</label>
            <select class="form-control  form-control-sm"
                    name="shipment-route-id"
                    [(ngModel)]="endIfDayParam.carrier_code">
                <option i18n [value]="null">No carrier assigned</option>
                <ng-template ngFor let-carrier [ngForOf]="carriers">
                    <option [value]="carrier.id">{{ carrier.name }}
                    </option>
                </ng-template>
            </select>
        </div>


        <app-spinner *ngIf="loading"></app-spinner>


        <button class="btn btn-primary" [disabled]="!endIfDayParam.carrier_code || loading" (click)="endOfDay()">End of day</button>
    </div>
</div>

